<div class="datepicker-section__header">
    <div class="field">Lägg till / Ta bort</div>
    <div class="field datepicker-section__checkboxes">
        <mat-checkbox
            [formControl]="form.controls.weekdaySelected"
            (change)="toggleAllWeekdays($event.checked)">Vardagar
        </mat-checkbox>

        <mat-checkbox
            [formControl]="form.controls.saturdaySelected"
            (change)="toggleAllSaturdays($event.checked)">Lördagar
        </mat-checkbox>

        <mat-checkbox
            [formControl]="form.controls.sundaySelected"
            (change)="toggleAllSundays($event.checked)">Sön- och helgdagar
        </mat-checkbox>
    </div>
</div>

<div class="datepicker-container">
    @for (month of selectedYear.calendarMonths; track month.start) {
        <div class="calendar-item">
            <div class="calendar-item__header">
                <button
                    mat-button
                    class="calendar-item__month-button"
                    (click)="toggleWholeMonthSelected(month)">
                    {{ month.header }}
                </button>
            </div>
            <ngb-datepicker
                [startDate]="toNgbDate(month.start)"
                [displayMonths]="1"
                [firstDayOfWeek]="1"
                [showWeekNumbers]="true"
                [navigation]="'none'"
                [outsideDays]="'visible'"
                [dayTemplate]="calendarDay"
                [markDisabled]="getMarkDisabled(month)"
                (dateSelect)="toggleNgbDate(month, $event)">
            </ngb-datepicker>

            <ng-template #calendarDay let-date let-currentMonth="currentMonth">
                <span
                    class="calendar-day"
                    [class.calendar-out-of-month]="date.month !== currentMonth"
                    [class.calendar-selected]="isDateSelected(month, date)"
                    [class.highlight-eve]="isHolidayByType(date, 1)"
                    [class.highlight-holiday]="isHolidayByType(date, 2)">
                    {{ date.day }}
                </span>
            </ng-template>
        </div>
    }
</div>
